module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic.15063648.eot";